import { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import './SubCategory.css';
import { subCategories as localSubs, businessServices, professionalServices } from '../../utils/categoryData';

export default function SubCategoryList() {
  const { categoryName } = useParams();
  const navigate = useNavigate();
  const name = decodeURIComponent(categoryName);

  // Local fallback se subcategories lo
  const subs = localSubs[name] || [];

  // Agar subcategories nahi hain to seedha business listing pe bhejo
  useEffect(() => {
    if (subs.length === 0) {
      navigate(`/subcategory/${encodeURIComponent(name)}/${encodeURIComponent(name)}`, { replace: true });
    }
  }, [name, subs.length, navigate]);

  if (subs.length === 0) return null;

  return (
    <div className="subcat-page">
      <div className="subcat-container">
        <h1 className="subcat-title">{name}</h1>
        <div className="subcat-list">
          {subs.map((sub, i) => (
            <div
              key={i}
              className="subcat-item"
              onClick={() => navigate(`/subcategory/${encodeURIComponent(name)}/${encodeURIComponent(sub.name)}`)}
            >
              <span className="subcat-name">{sub.name}</span>
              <span className="subcat-icon">{sub.icon}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
